















































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import Supervisor from "./component/SupervisorV2.vue";
import { authorClient } from "@/api/index";
//import { CommonReq} from "@/pbjs/xcommon/module_pb";
import { errorMsg, setCommon } from "@/utils/request";
@Component({
  name: "system",
  components: { Supervisor },
})
export default class UserManagement extends Vue {
  @Provide() private input: string = "";
  @Provide() private tableData: any = [];
  @Provide() private token: string | null = "";
  @Provide() private roleValue: string = "";
  @Provide() private roleOptions: any = [];
  @Provide() private data: any[] = [];
  @Provide() private isAddMainNode: boolean = false;
  @Provide() private tempId: number = 0;
  @Provide() private isMainEdit: boolean = false;
  @Provide() private defaultCheckKeys: any = [];
  @Provide() private searchDataIndex: number = -1;
  @Provide() private findShowBox: boolean = false;
  @Provide() private findShowId: string | number = -1;
  @Provide() private firstLoadPage: boolean = false; // 进入页面后默认点击第一个角色组
  @Provide() private userGroupType: any = null;
  @Provide() private showUserGroupType: boolean = false;

  private created() {
    this.token = localStorage.getItem("token");
    this.firstLoadPage = true;
    this.getRoleListAPI();
    this.getRoleTree();
  }
  @Watch("roleValue")
  onRoleValueChanged(val: string) {
    if (val) {
      this.searchDataIndex = -1;
      this.searchName(val, this.data, "name");
      if (this.searchDataIndex >= 0) {
        this.showRoleBox(this.data[this.searchDataIndex], this.searchDataIndex);
      }
    }
  }

  private getRoleListAPI() {
    let request: any = setCommon();
    authorClient.listUserGroup(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (!data.commonout || data.commonout.code == 0) {
          if (data.usergroupinfosList) {
            this.roleOptions = data.usergroupinfosList;
          }
        } else if (data.code == 100100 || data.code == 100101) {
          this.$router.push("./login");
        } else {
          this.$message.error(data.commonout.errmsg);
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getRoleTree() {
    let request: any = setCommon();
    authorClient.getUserGroupTree(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.commonout) {
          if (data.commonout.code == 0) {
            if (data.treeList) {
              // let list: any = this.addPropertyEdit(data.treeList);
              // this.data = list;
              this.data = data.treeList;
              this.setAllRoleBoxHidden();
              this.data = this.findTreeIndex(this.data, 1);
              if (this.findShowBox) {
                this.searchDataIndex = -1;
                this.searchName(this.findShowId, this.data, "id");
                if (this.searchDataIndex >= 0) {
                  this.showRoleBox(this.data[this.searchDataIndex], this.searchDataIndex);
                }
              }
              if (this.firstLoadPage) {
                if (this.data.length > 0) {
                  this.showRoleBox(this.data[0], 0);
                }
              }
            }
          } else if (data.commonout.code == 100100 || data.code == 100101) {
            this.$router.push("./login");
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        } else {
          if (data.code == 0) {
            if (data.treeList) {
              // let list: any = this.addPropertyEdit(data.treeList);
              // this.data = list;
              this.data = data.treeList;
              this.setAllRoleBoxHidden();
              this.data = this.findTreeIndex(this.data, 1);
              if (this.findShowBox) {
                this.searchDataIndex = -1;
                this.searchName(this.findShowId, this.data, "id");
                if (this.searchDataIndex >= 0) {
                  this.showRoleBox(this.data[this.searchDataIndex], this.searchDataIndex);
                }
              }
              if (this.firstLoadPage) {
                if (this.data.length > 0) {
                  this.showRoleBox(this.data[0], 0);
                }
              }
            }
          } else if (data.code == 100100 || data.code == 100101) {
            this.$router.push("./login");
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
      }
      if (err) {
        errorMsg(err);
      }
      this.firstLoadPage = false;
    });
  }

  private addPropertyEdit(data: any) {
    data.forEach((item: any) => {
      item.edit = false;
      item.label = item.rolename;
      item.id = item.roleid;
      item.children = item.kidrolesList;
      if (item.kidrolesList) {
        this.addPropertyEdit(item.kidrolesList);
      }
    });
    return data;
  }

  private inquireRole() {}

  private selectTypeCreateMainRole() {
    this.showUserGroupType = true;
  }

  private userGroupTypeChange(val: any) {
    if (val === 1 || val === 2 || val === 3 || val === 4 || val === 7) {
      this.showUserGroupType = false;
      this.createMainRole(val);
    }
  }

  private createMainRole(val: number) {
    if (!this.isMainEdit) {
      this.isAddMainNode = true;
      this.isMainEdit = true;
      this.setAllRoleBoxHidden();
      this.data.push({
        id: this.tempId++,
        name: "",
        edit: true,
        kidsList: [],
        show: true,
        ext: { exectype: val },
      });
    }
  }

  private returnRemoveNode(id: any) {
    let index: number = -1;
    this.data.forEach((item: any, ind: number) => {
      if (id === item.id) {
        index = ind;
      }
    });
    this.data.splice(index, 1);
  }

  private returnIsMainEdit(data: any) {
    this.isMainEdit = false;
  }

  private findTreeIndex(tree: any, index: number) {
    tree.forEach((item: any) => {
      item.index = index;
      if (item.kidsList) {
        let tempIndex = index;
        this.findTreeIndex(item.kidsList, ++tempIndex);
      }
    });
    return tree;
  }

  private returnRefreshTree(id: number | string) {
    if (id) {
      this.findShowBox = true;
      this.findShowId = id;
    }
    this.getRoleTree();
    this.defaultCheckKeys = [Number(id)];
  }

  private showRoleBox(item: any, index: number) {
    this.setAllRoleBoxHidden();
    item.show = true;
    this.$set(this.data, index, item);
  }

  private setAllRoleBoxHidden() {
    this.data.forEach((item: any, index: number) => {
      this.data[index].show = false;
    });
  }

  private returnShowNewItem(id: any) {
    // this.searchDataIndex = -1;
    //     this.searchName(val, this.data, "name");
    //     if (this.searchDataIndex >= 0) {
    //         this.showRoleBox(this.data[this.searchDataIndex], this.searchDataIndex);
    //     }
  }

  private searchName(val: string | number, data: any, type: string, index: number = -1) {
    for (let i = 0; i < data.length; i++) {
      if (data[i][type] == val) {
        this.searchDataIndex = index === -1 ? i : index;
        break;
      }
      if (data[i].kidsList.length > 0) {
        let ind: number = index === -1 ? i : index;
        this.searchName(val, data[i].kidsList, type, ind);
      }
    }
  }
}
